import React, { Component } from 'react';
import SettingsBlock from 'Components/Common/Settings/SettingsBlock';
import ConverterSettingsStore from 'Stores/converterSettingsStore';
import { observer } from 'mobx-react';
import 'Styles/converterSettings.scss'
import LoadView from "Components/Common/loadView";
import { Navigate } from 'react-router-dom';
import AppStore from 'Stores/AppStore';
import TextInputSetting from 'Components/Common/Settings/TextInputSetting';
import TextSetting from 'Components/Common/Settings/TextSetting';
import SwitcherSetting from 'Components/Common/Settings/SwitcherSetting';

class ConverterSettings extends Component {
    componentDidMount() {
        AppStore.OnMainComponentMount('Настройки конвертера файлов', 'converter');

        ConverterSettingsStore.GetSettings();
    }

    render() {
        if (this.props.migrationInProcess) {
            return (
                <Navigate to={`${window.SmrLocation}/migration`} />
            )
        }

        let serviceStateClass = !ConverterSettingsStore.smrConverterStatus.isActive
            ? 'text-setting-disabled' : ConverterSettingsStore.smrConverterStatus.hasError
                ? 'text-setting-bad' : 'text-setting-good';

        let deloServiceStateClass = !ConverterSettingsStore.deloConverterStatus.isActive
            ? 'text-setting-disabled' : ConverterSettingsStore.deloConverterStatus.hasError
                ? 'text-setting-bad' : 'text-setting-good';

        let fileStorageStateClass = '';
        let freeSpaceDescription = '';
        let freeSpaceErrorDescription = '';
        switch (ConverterSettingsStore.freeSpaceStatus) {
            case 1:
                freeSpaceDescription = "более 10 Гб";
                break;
            case 2:
                freeSpaceDescription = "менее 10 Гб";
                fileStorageStateClass = 'text-setting-bad'
                freeSpaceErrorDescription = "Заканчивается свободное место в файловом хранилище СМР. Осталось меньше 10 Гб. СМР будет автоматически остановлен, если в файловом хранилище будет меньше 500 Мб.";
                break;
            case 3:
                freeSpaceDescription = "недостаточно свободного места";
                fileStorageStateClass = 'text-setting-good'
                freeSpaceErrorDescription = "Работа сервиса СМР остановлена, так как недостаточно свободного места в файловом хранилище. Для перезапуска сервиса СМР в файловом хранилище должно быть больше 1 Гб свободного места.";
                break;
            default:
                freeSpaceDescription = "неизвестно";
                break;
        }

        return (
            <div className={'converter-settings'}>
                <div className='converter-settings-settings-container'>
                    <SettingsBlock
                        key='converter-switcher-block'
                        title='Конвертация файлов в СЭД "Дело"'>

                        <SwitcherSetting
                            id='delo-converter-service-switcher'
                            key='delo-converter-service-switcher'
                            title='Конвертировать файлы в PDF-формат с помощью СЭД "ДЕЛО"'
                            value={ConverterSettingsStore.settings.deloConvert}
                            onChanged={(value) => ConverterSettingsStore.SetConverterSetting('deloConvert', value)} />

                        <TextSetting
                            id='delo-converter-service-status'
                            key='delo-converter-service-status'
                            title='Статус:'
                            className={deloServiceStateClass}
                            value={ConverterSettingsStore.deloConverterStatus.status} />

                    </SettingsBlock>

                    <SettingsBlock
                        key='converter-settings-block'
                        title='Конвертер файлов'>

                        <TextInputSetting
                            id='converter-service-path'
                            key='converter-service-path'
                            title='URL сервиса конвертации:'
                            disabled={ConverterSettingsStore.settings.deloConvert}
                            value={ConverterSettingsStore.settings.servicePath}
                            onChanged={(value) => ConverterSettingsStore.SetConverterSetting('servicePath', value)} />

                        <TextSetting
                            id='converter-service-status'
                            key='converter-service-status'
                            title='Статус:'
                            className={serviceStateClass}
                            value={ConverterSettingsStore.smrConverterStatus.status} />

                    </SettingsBlock>

                    <SettingsBlock
                        key='storage-settings-block'
                        title='Мониторинг файлового хранилища'>

                        <TextSetting
                            id='storage-status'
                            key='storage-status'
                            title='Свободного места на диске:'
                            className={fileStorageStateClass}
                            value={freeSpaceDescription} />

                        {
                            freeSpaceErrorDescription ?
                                <TextSetting
                                    id='storage-error-status'
                                    key='storage-error-status'
                                    title='Пояснение:'
                                    className={fileStorageStateClass}
                                    value={freeSpaceErrorDescription} />
                                : ''
                        }
                    </SettingsBlock>
                </div>
                <div className='settings-buttons-container'>
                    <button className="blue-button"
                        onClick={_ => ConverterSettingsStore.SaveSettings()}>Сохранить</button>
                </div>
                {ConverterSettingsStore.settingsLoading ? <LoadView modal={true} /> : ''}
            </div>
        )
    }
}

export default observer(ConverterSettings);